const { InspectorControls } = wp.blockEditor;
const { PanelBody, PanelRow, TextControl, ToggleControl } = wp.components;

export default ({ attributes, setAttributes }) => {
  const { isImageAbsolute, hasImageOnRight, imageHeight, imageWidth, imageOffset, gap } = attributes;

  return (
    <InspectorControls>
      <PanelBody title="Opções da imagem" initialOpen={true}>
        <PanelRow>
          <ToggleControl
            label="Absoluta"
            checked={isImageAbsolute}
            onChange={(isImageAbsolute) => setAttributes({ isImageAbsolute })}
          />
        </PanelRow>
        <PanelRow>
          <ToggleControl
            label="Mostrar imagem na direita"
            checked={hasImageOnRight}
            onChange={(hasImageOnRight) => setAttributes({ hasImageOnRight })}
          />
        </PanelRow>
        <PanelRow>
            <TextControl
              label="Largura no celular (px)"
              value={imageWidth}
              onChange={(imageWidth) => setAttributes({ imageWidth })}
            />
        </PanelRow>
        <PanelRow>
          <TextControl
            label="Altura no celular (px)"
            value={imageHeight}
            onChange={(imageHeight) => setAttributes({ imageHeight })}
          />
        </PanelRow>
        <PanelRow>
          <TextControl
            label="Deslocamento (px)"
            value={imageOffset}
            onChange={(imageOffset) => setAttributes({ imageOffset })}
          />
        </PanelRow>
      </PanelBody>
      <PanelBody title="Opções gerais">
        <PanelRow>
          <TextControl
            label="Vão entre imagem e texto (px)"
            value={gap}
            onChange={(gap) => setAttributes({ gap })}
          />
        </PanelRow>
      </PanelBody>
    </InspectorControls>
  )
}
